// Projects view + left menu glyphs: icons only this lane uses (docs/implement/lanes.md).
// Key = the icon's name, value = a lucide-react component, as in Icon.tsx.

export { projectsGlyphs };

import {
    ArrowDownWideNarrow,
    CornerDownRight,
    GraduationCap,
    Languages,
    LayoutGrid,
    Lightbulb,
    List,
    Monitor,
    SquarePen,
    SunMoon,
    Table2,
} from "lucide-react";
import type { AreaGlyphs } from "../Icon";

const projectsGlyphs = {
    list: List, // a list (the Studio's outline heading and its mode switch)
    "layout-grid": LayoutGrid, // the Projects page's Cards view; the menu's Projects entry
    "square-pen": SquarePen, // the menu's Studio entry and the empty Studio
    lightbulb: Lightbulb, // the New project box's writing hint
    "sun-moon": SunMoon, // the left menu's Theme row
    languages: Languages, // the left menu's Language row
    monitor: Monitor, // the theme that follows the computer
    table: Table2, // the Projects page's Table view
    sort: ArrowDownWideNarrow, // the Projects page's Sort button
    "corner-down-right": CornerDownRight, // "You were in <page>"
    "graduation-cap": GraduationCap, // a project whose content is one course
} satisfies AreaGlyphs;
